import React, { useState } from "react";
import PropTypes from "prop-types";
import { Button, Row, UncontrolledTooltip } from "reactstrap";
import ExerciseKey from "../ExerciseKey";
import Animate from "./Animate";
import { Rate } from "antd";
// import url_0 from './assets/0.mp3'
// import url_1 from './assets/1.mp3'
// import url_2 from './assets/2.mp3'
// import url_3 from './assets/3.mp3'
// import url_4 from './assets/4.mp3'
// import url_5 from './assets/5.mp3'
import styles from "./styles.module.css";
import GuideModal from "../GuideModal/GuideModal";
import NewWords from "../NewWords/NewWords";

const FooterModal = ({
  resultStringProps,
  result,
  isDisabledSubmit,
  isDisabledRetry,
  onRetry,
  onSubmit: onSubmitProps,
  audioUrl,
  autoPlay,
  exerciseKey,
  exerciseKeySize,
  starCircle,
  hideBtnFooter,
  isEssay = false,
  guideModal,
  newWords,
  isTuLuan,
  isHello,
  countStudentAnswer,
}) => {
  const [state, setState] = React.useState({
    data: null,
    audio: null,
    onRetrying: false,
    keysVisible: false,
    videoVisible: false,
    audioVisible: true,
    keyButtonVisible: false,
  });
  const toggleState = React.useCallback(
    (fieldName) => () => {
      setState((prevState) => ({
        ...prevState,
        [fieldName]: !prevState[fieldName],
      }));
    },
    []
  );
  const toggleDrawer = React.useCallback(() => { 
    if(state.keyButtonVisible === false){
    setState((prevState) => ({
      ...prevState,
      keysVisible: !prevState.keysVisible,
    }));
  }
  }, []);
  const onSubmit = React.useCallback(() => {
    onSubmitProps?.();
    if(result[0]){
      setState((prevState) => ({ ...prevState, keyButtonVisible: false }));
    }else{setState((prevState) => ({ ...prevState, keyButtonVisible: true }));}
    
  }, [onSubmitProps]);

  const resultString = React.useCallback(() => {
    let correctAnswer = 0;
    if (!result) return;

    result.forEach((item, index) => {
      if (item) {
        correctAnswer++;
      }

    });
    const percent = starCircle >= 0 ? starCircle : parseInt((correctAnswer / result.length) * 100);
  
    const star =percent / 20;
    
    return star;
  }, [result ]);

  return (
    <Row className="d-flex justify-content-center mt-2 mb-2">
      <div
        style={{
          position: "fixed",
          bottom: 10,
          display: "flex",
          width: "100%",
          justifyContent: "center",
          backgroundColor: "white",
          padding: 10,
          height: 64,
        }}
      >
        <div className="d-flex" style={{ flexDirection: "row", width: "90%" }}>
          {/* Button Key */}
          <div
            className={`${styles.wrapColLeft}`}
            style={{ alignContent: "center" }}
          >
            {countStudentAnswer >= 2 && !isTuLuan && state.keyButtonVisible ? (
              isHello === true ? (
                <Button color="success">Nộp bài thành công</Button>
              ) : (
                <Button
                  id="key"
                  color="info"
                  type="button"
                  className="btn-icon btn-2"
                  onClick={toggleDrawer}
                >
                  <span className="btn-inner--icon">
                    <i className="fas fa-key"></i>
                  </span>
                </Button>
              )  
            ) : (
              isTuLuan &&
              state.keyButtonVisible && (
                <Button
                  id="key"
                  color="info"
                  type="button"
                  className="btn-icon btn-2"
                  onClick={toggleDrawer}
                >
                  <span className="btn-inner--icon">
                    <i className="fas fa-key"></i>
                  </span>
                </Button>
              )
            )}

            {/* Button AUDIO */}
            {/* {audioUrl && (
              <>
                <Button
                  id="tooltip611234742"
                  color="info"
                  type="button"
                  className="btn-icon btn-2"
                  onClick={toggleState('audioVisible')}
                >
                  <span className="btn-inner--icon">
                    <i className="fas fa-headphones-alt"></i>
                  </span>
                </Button>
                <UncontrolledTooltip
                  delay={0}
                  placement="top"
                  target="tooltip611234742"
                >
                  Audio
                </UncontrolledTooltip>
              </>
            )} */}
            {(result || resultStringProps) &&
              state.keyButtonVisible &&
              !isDisabledRetry &&
              !isTuLuan &&
              !isHello && (
                <>
                  {/* <Rate value={resultString()} /> */}
                  <Animate resultString={resultString()} />
                  <audio className={styles.audio} id='myAudio' autoPlay>
                  {/* <source src={getAudioUrl(state.audio)} type='audio/mpeg' /> */}
                </audio>
                </>
              )}
          </div>
          {state.audioVisible && audioUrl && (
            <div
              className={`${styles.wrapColCenter} justify-center items-center`}
            >
              <div>
                <audio
                  className={styles.audio}
                  id="myAudio"
                  controls
                  autoPlay={autoPlay}
                >
                  <source src={audioUrl} type="audio/mpeg" />
                </audio>
              </div>
            </div>
          )}
          <div className={`${styles.wrapColRight}`}>
            {
              <>
                <div
                  style={{
                    display: "flex",
                    paddingRight: hideBtnFooter ? 200 : 0,
                  }}
                >
                  {/* button huong dan */}
                  <GuideModal guideModal={guideModal} />

                  {/* button tra cuu */}
                  <NewWords newWords={newWords} />
                </div>

                <Button
                  type="button"
                  color="danger"
                  // className="ml-2"
                  data-dismiss="modal"
                  disabled={isDisabledRetry}
                  hidden={hideBtnFooter}
                  onClick={() => {
                    onRetry();
                    if (isEssay)
                      setState((prevState) => ({
                        ...prevState,
                        keyButtonVisible: false,
                      }));
                  }}
                >
                  LÀM LẠI
                </Button>
                <Button
                  type="button"
                  color="danger"
                  // className="ml-auto"
                  data-dismiss="2"
                  disabled={isDisabledSubmit}
                  hidden={hideBtnFooter}
                  onClick={onSubmit}
                >
                  NỘP BÀI
                </Button>
              </>
            }
          </div>
        </div>
      </div>
      <ExerciseKey
        exerciseKey={exerciseKey}
        exerciseKeySize={exerciseKeySize}
        visible={state.keysVisible}
        onClose={() =>
          setState((prevState) => ({
            ...prevState,
            keysVisible: !prevState.keysVisible,
          }))
        }
      />
      {/* <VideoModal ref={videoModal} videoUrl={videoUrl} /> */}
    </Row>
  );
};

FooterModal.propTypes = {
  questions: PropTypes.instanceOf(Object),
  isVisibled: PropTypes.bool,
  toggleModal: PropTypes.func,
};

export default FooterModal;
